
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","height":"48","width":"48"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('title',[_v('move-left')]),_c('line',{attrs:{"x1":"0.75","y1":"11.998","x2":"11.25","y2":"11.998","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}}),_c('polyline',{attrs:{"points":"4.5 8.248 0.75 11.998 4.5 15.748","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}}),_c('rect',{attrs:{"x":"15.75","y":"0.748","width":"7.5","height":"22.5","rx":"1.5","ry":"1.5","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}})])
          )
        }
      }
    